import React, { useRef } from 'react';
import { useDayRender } from 'react-day-picker';
import cn from 'classnames';

import styles from './Day.module.scss';

const Day = ({
  date,
  displayMonth,
  ...restProp
}: {
  date: any;
  displayMonth: any;
  restProp: any;
}) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const { isHidden, buttonProps, activeModifiers } = useDayRender(
    date,
    displayMonth,
    buttonRef,
  );

  if (isHidden) {
    return <div className={styles.day} role="gridcell" />;
  }

  return (
    <button
      type="button"
      {...buttonProps}
      ref={buttonRef}
      className={cn(styles.day, {
        [styles.dayOutside]: activeModifiers.outside,
        [styles.dayToday]: activeModifiers.today,
        [styles.daySelected]: activeModifiers.selected,
      })}
    />
  );
};

export default React.memo(Day) as any;
